import { render, staticRenderFns } from "./management.vue?vue&type=template&id=28771b9f&scoped=true&"
import script from "./management.vue?vue&type=script&lang=js&"
export * from "./management.vue?vue&type=script&lang=js&"
import style0 from "./management.vue?vue&type=style&index=0&id=28771b9f&scoped=true&lang=css&"
import style1 from "./management.vue?vue&type=style&index=1&id=28771b9f&lang=less&scoped=true&"
import style2 from "./management.vue?vue&type=style&index=2&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28771b9f",
  null
  
)

export default component.exports